import React from "react";
import { Input } from "antd";

const TextAreaWrapper = ({ className = "", inputClass = "", rows = 5, ...props }) => {
    const { TextArea } = Input;

    return (
        <div
            className={`
                relative w-full rounded-lg border-2 border-gray-50 bg-gray-50
                focus-within:border-emerald-500
                focus-within:ring-emerald-500/50 focus-within:ring-2
                transition-all duration-150
                ${className}
            `}
        >
            <TextArea
                allowClear
                variant="borderless"
                rows={rows}
                maxLength={255}
                className={`
                    resize-none bg-transparent pr-3 text-[13px] sm:text-[14px] 
                    placeholder:text-muted-foreground
                    disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50
                    ${inputClass}
                `}
                {...props}
            />
        </div>
    );
};

export default TextAreaWrapper;